<template>
  <tr @dblclick="$refs['actions'].callFirstStarredAction();"
    class="d-block d-lg-table-row bg-white px-2 py-2 mb-2 border p-lg-0 mb-lg-0 border-lg-0">
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Objective user') }}</span>
      <FieldReadonly :value="getUserFullName(changeLog.externalUser)" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('User making the change') }}</span>
      <FieldReadonly :value="getUserFullName(changeLog.actionExternalUser)" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Date') }}</span>
      <FieldReadonly :value="changeLog.created_at" format="datetime" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Field/Application') }}</span>
      <FieldReadonly :value="changeLog.field" />
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('Old value') }}</span>
      <FieldReadonly v-html="changeLog.old_value" />
      
    </td>
    <td class="d-block d-lg-table-cell">
      <span class="small d-lg-none fw-bold" data-no-export>{{ i18n('New value') }}</span>
      <FieldReadonly v-html="changeLog.new_value" />
      
    </td>
    <td data-no-export class="d-block d-lg-table-cell text-end border-0 border-lg-bottom" @click.stop>
      <ActionDropdown ref="actions" :actions="actions" />
    </td>
  </tr>
</template>

<script>
import FieldReadonly from "@/components/common/form/FieldReadonly.vue";
import Field from "@/components/common/form/Field.vue";
import ActionDropdown from "@/components/common/list/ActionDropdown.vue";

export default {
  components: {
    FieldReadonly,
    Field,
    ActionDropdown,
  },
  props: {
    changeLog: Object,
  },
  data() {
    return {};
  },
  emits: [
    'deleted',
    'updating',
    'updated',
  ],
  methods: {
    getUserFullName(user) {
      if (!user) return '';
      const { first_name = '', last_name = '' } = user;

      return `${first_name} ${last_name}`.trim();
    }
  },
  computed: {
    actions() {
      return [{
        label: this.i18n('Detail'),
        fn: () => {
          this.$router.push({ name: 'ChangeLog', params: { id: this.ChangeLog.id } });
        },
        if: false,
        starred: true,
      },
      ];
    },
  },
};
</script>